var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { LabeledInput, Wrapper } from './TopLabeledTextField.Styles';
export var TopLabeledTextField = function (props) {
    return (React.createElement(Wrapper, { half: props.half },
        React.createElement(LabeledInput, __assign({}, props, { style: props.width ? { width: props.width } : {}, placeholder: props.placeholder || props.label, onChange: function (e) { return props.onChange && props.onChange(e); }, variant: 'outlined', margin: 'dense', InputLabelProps: {
                shrink: true
            }, InputProps: {
                notched: false
            } }))));
};
TopLabeledTextField.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=TopLabeledTextField.js.map